import { ApiFetchType } from '@/server/api-fetch';

export type SocialLink = {
    network: string;
    href: string;
};

export type Column = {
    header: string;
    headingLevel?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    content: string;
    open?: boolean;
    options?: {
        socials?: boolean;
        qrcolumn?: boolean;
    };
};

export type FooterApiTypeResponse = {
    columns: Column[];
    copyright: string;
    socialLinks?: SocialLink[];
    qr?: {
        qrImg: string | number | false;
        qr_header: string;
        qrLink?: string;
        appStoreLink?: string;
        appStoreLinkText?: string;
        googlePlayLink?: string;
        googlePlayLinkText?: string;
    };
    clusterColumns?: Column[];
    clusterCopyright?: string;
    clusterSocialLinks?: SocialLink[];
};

export const FOOTER_QUERY_KEY = 'footer';

export const getFooter = async (context: ApiFetchType) => {
    if (!context.fetch) {
        return null;
    }

    const { columns, copyright, socialLinks, clusterColumns, clusterSocialLinks, clusterCopyright, qr } =
        await context.fetch<FooterApiTypeResponse>('api/general/footer');

    return {
        columns,
        copyright,
        socialLinks,
        clusterColumns,
        clusterSocialLinks,
        clusterCopyright,
        qr,
    };
};
